import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { HighchartsThemeService, ResponsiveService } from '@frk/eds-components';
import { SiteConfigService } from '@services';
import { TableResponsiveService } from '@shared/table/table-responsive.service';
import { setHighChartLangOptions } from '@utils/il8n/moment-il8n';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-distribution-chart-view',
  templateUrl: './distribution-chart-view.component.html',
  styleUrls: ['./distribution-chart-view.component.scss'],
  providers: [TableResponsiveService],
})
export class DistributionChartViewComponent implements OnInit, OnChanges {
  @Input() highChartOptions: Highcharts.Options;
  public highcharts;
  public chartOptions: Highcharts.Options = {};

  public isMobile$: Observable<boolean>;

  constructor(
    private highchartsTheme: HighchartsThemeService,
    private siteConfig: SiteConfigService,
    private responsiveService: ResponsiveService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.isMobile$ = this.responsiveService.isMobile$();
  }

  ngOnInit(): void {
    import(
      /* webpackChunkName: "distribution-chart-highstock-async" */ 'highcharts/highstock'
    ).then((highchartsModule) => {
      highchartsModule.setOptions({
        lang: setHighChartLangOptions(this.siteConfig.getPdsLanguage()),
      });
      highchartsModule.setOptions(this.highchartsTheme.themeOptions);
      require('highcharts/modules/accessibility')(highchartsModule);
      this.highcharts = highchartsModule;
    });
    this.chartOptions = this.highChartOptions;
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.chartOptions = changes.highChartOptions.currentValue;
  }
}
